var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRangoHumedad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#4d7fe2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-rango-humedad") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_12",
    "data-name": 12
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.14,105.57q0,16.11,0,32.22a2.38,2.38,0,0,0,.86,1.94,18.93,18.93,0,1,1-31.44,17.34,18.33,18.33,0,0,1,5.76-17.33,2.53,2.53,0,0,0,.87-2q0-31.88,0-63.74A12,12,0,0,1,151,72.32a21.05,21.05,0,0,1,.1,2.25Zm-4,1.27c0-11,0-21.9,0-32.85a7.7,7.7,0,0,0-4.69-7.46A8,8,0,0,0,131.16,74q0,33,0,65.91a1.93,1.93,0,0,1-.87,1.78,14.43,14.43,0,0,0-6.07,12,14.91,14.91,0,1,0,23.78-12,2,2,0,0,1-.9-1.86Q147.14,123.32,147.12,106.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.28,73.33v3.89H155V73.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,130v-3.89h17.22V130Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,103.63V99.77h17.25v3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,113v3.88H155V113Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,86.4v3.86H155.06V86.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.16,118.2c0,7.87,0,15.74,0,23.6a2.53,2.53,0,0,0,1.54,2.33,11.08,11.08,0,1,1-11.18.06,3,3,0,0,0,1.63-2.91q0-23.09,0-46.18a6.41,6.41,0,0,1,.6-2.74,3.73,3.73,0,0,1,4.1-1.87,4,4,0,0,1,3.2,3.2,5.78,5.78,0,0,1,.1,1Q143.17,106.46,143.16,118.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.13,170.75c-5.5,3.47-9.13,5-15.88,4.91-12.12-.18-21.18-5.68-26.95-16.35-4.71-8.73-5-18-.72-27.47C84.18,117,90.9,102,97.41,87.46q3.75-8.38,7.51-16.79l1.1,2.16,4.3,8.42q3.54,6.93,7.07,13.86c1.64,3.2,3.29,6.45,5,9.7V90.53l-4.16-8.14L108.11,62.65l-.09-.18a8.43,8.43,0,0,0-.7-1.2,3.18,3.18,0,0,0-5.35.18,7,7,0,0,0-.52,1l-.08.19L92.91,81.57,88.2,92.09l-.91-1.68q-3.24-6-6.47-11.93a3.49,3.49,0,0,0-3.24-2.18,3.54,3.54,0,0,0-3,2.23l-5,9.81c-3.35,6.57-6.81,13.37-10.17,20.09A20.88,20.88,0,0,0,64.5,134.3,27.1,27.1,0,0,0,68,136.72l1,.61a35.71,35.71,0,0,0,.69,17.9c4.14,13.38,13.1,22.05,26.62,25.8a38.92,38.92,0,0,0,4.43.87c.65.1,1.33.21,2,.33l.1,0h5.67l.16-.06a2,2,0,0,0,.26-.09l.19-.06c8.23-1,12.52-3.42,18.26-7.66ZM70.91,130.91a11.92,11.92,0,0,1-3.7-3c-4.2-5-5-10.45-2.24-16.07,3-6.3,6.29-12.64,9.44-18.77l3.37-6.59.67,1.24c2.19,4,4.25,7.83,6.31,11.72a1.83,1.83,0,0,1-.14.59c-3.07,6.91-6.2,13.93-9.23,20.72-1.22,2.71-2.43,5.43-3.64,8.14C71.46,129.57,71.19,130.22,70.91,130.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRangoHumedad);
export default __webpack_public_path__ + "static/media/ic-rango-humedad.1a1adb967d9e0edf1ec17781df3d4763.svg";
export { ForwardRef as ReactComponent };